var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":_vm.cols}},[_c('h2',{staticClass:"font-weight-bold primary--text mb-4",class:_vm.$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }